export class Property {

	constructor() {
		this.id = "00000000-0000-0000-0000-000000000000";
		this.value = "";
	}

	public id: string;
	public name: string;
	public value: string;
	public type: string;
}